// extracted by mini-css-extract-plugin
export default {"Wrapper":"CodeOfConductPdf_Wrapper__pPNqY"};